import React from 'react';
import '../styles.scss';

import NoticeCardHeader from './notice-card-header';
import NoticeCardFooter from './notice-card-footer';
import { ENUM_NOTICE_STATUS } from 'utils/enum';

export type NoticeDataType = {
  id: string;
  title: string;
  description: string;
  start_time: string;
  end_time: string;
  created_at: string;
  updated_at: string;
  status: ENUM_NOTICE_STATUS;
};

const NoticeCard = ({ data }: { data: NoticeDataType }) => {
  return (
    <div className='notice-card relative'>
      <NoticeCardHeader data={data} />
      <p className='px-[18px] py-4 leading-[170%] grow'>{data.description}</p>
      <NoticeCardFooter data={data} />
    </div>
  );
};

export default NoticeCard;
